export const ENV = process.env.REACT_APP_ENV;

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_FILE_URL = process.env.REACT_APP_API_FILE_URL;
export const API_LOGO_BASE_URL = process.env.REACT_APP_API_LOGO_BASE_URL;
export const APPLICATION_SERVICE_URL = process.env.REACT_APP_APPLICATION_SERVICE_URL;

export const ADB2C_REDIRECT_URL = process.env.REACT_APP_Adb2cConfig_TenantRedirectUrl;
export const ADB2C_TENANT_ID = process.env.REACT_APP_Adb2cConfig_TenantId;

export const STORAGE_ACCOUNT = process.env.REACT_APP_STORAGE_ACCOUNT;
export const NODE_ENV = process.env.NODE_ENV;
export const PUBLIC_URL = process.env.PUBLIC_URL;

export const IS_DEV = ENV === "development";
export const IS_STAGING = ENV === "staging";
export const IS_PREPROD = ENV === "preproduction";
export const IS_PROD = ENV === "prod";
